import { Tab } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { useContext } from "react";
import { BoletoContext } from "../../contexts/BoletoContext";
import useBilletController from "../../controllers/BoletoController";
import { BoletoGridChild } from "../../styles/Boleto";
import { BilletTypes } from "../BilletTypes";

import { BoletoTable } from "./BoletoTable";
import { BoletoHeader } from "./ContractHeader";

const BoletoGrid = () => {
  const { billetType } = useContext(BoletoContext);

  const { selectBilletType } = useBilletController();

  return (
    <BoletoGridChild>
      <BoletoHeader />
      <TabContext value={billetType}>
        <TabList
          onChange={selectBilletType}
          variant="fullWidth"
          style={{ borderBottom: "1px solid #e6e6e6" }}
        >
          <Tab
            label="Boletos Pendentes"
            value={BilletTypes.accountsReceivable}
          />
          <Tab label="Boletos Pagos" value={BilletTypes.paidAccounts} />
        </TabList>
        <TabPanel value={BilletTypes.accountsReceivable}>
          <BoletoTable />
        </TabPanel>
        <TabPanel value={BilletTypes.paidAccounts}>
          <BoletoTable />
        </TabPanel>
      </TabContext>
    </BoletoGridChild>
  );
};

export default BoletoGrid;
